import { render } from "./Sorteios.vue?vue&type=template&id=3ae319b2"
import script from "./Sorteios.vue?vue&type=script&lang=js"
export * from "./Sorteios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__